const BACKGROUND_COLOR = "background-color";
const FOREGROUND_COLOR = "foreground-color";
const TEXT_BUTTON_TEXT_COLOR = "text-button-text-color";
const TEXT_BUTTON_TEXT_HIGHLIGHT = "text-button-text-highlight";
export {
  BACKGROUND_COLOR,
  FOREGROUND_COLOR,
  TEXT_BUTTON_TEXT_COLOR,
  TEXT_BUTTON_TEXT_HIGHLIGHT
};
//# sourceMappingURL=data-hooks.js.map
